import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { LoaderRegistryService } from '../../services/loader-registry.service';

@Component({
  selector: 'myt-app-top-loader-bar',
  templateUrl: './app-top-loader-bar.component.html',
  styleUrls: ['./app-top-loader-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppTopLoaderBarComponent {
  readonly topBarVisible$: Observable<boolean> =
    this.loaderRegistryService.selectTopBarVisible();

  constructor(private readonly loaderRegistryService: LoaderRegistryService) {}
}
